import { call, put, select, takeEvery } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { CompleteChartConstants } from '../store/completeChart.constants'
import { preSubmitChart } from '../../submitChart/store/submitChart.actions'
import { ILockChartActionPayload } from '../store/completeChart.types'

export function* lockCurrentChart(actionPayload: ILockChartActionPayload) {
  const { shouldUploadChart, lockChart } = actionPayload
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)

  if (pcrID) {
    try {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)

      const pcrDocUpdated: IPcr = {
        ...pcrDoc,
        isChartLockedIn: lockChart,
        completeChart: { ...pcrDoc.completeChart, lockChart },
      }
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      if (shouldUploadChart) yield put(preSubmitChart())
    } catch (e) {
      yield put(throwPcrException(`lockCurrentChart() error: ${e}`))
    }
  }
}

export function* lockCurrentChartSaga() {
  yield takeEvery([CompleteChartConstants.SET_LOCK_CHART], performWithMutexHOG, lockCurrentChart)
}
